<!-- VRGroups base component for starting services on load -->

<!-- Follow train overlay is VR-only component that is displayed over the map when train is being followed -->
<qm-follow-train-overlay></qm-follow-train-overlay>